import TrackingService from "./tracking_service";
import Slide from "./slide";

export default class PromoShopPromo {

    constructor() {
        this.trackingService = new TrackingService()
    }

    trackClick(clickableItem, position, filledSlots, promoType) {
        const container = this.findParentContainer(clickableItem, promoType);
        const featureOrder = this.getFeatureOrder(container);
        const featureIndex = this.getFeatureIndex(container);
        const featureLabels = this.getFeatureLabels(container);
        const masTrackingFeatureLabels = this.getMasFeatureTrackingLabels(container);

        let slide = new Slide(clickableItem.parentElement.parentElement);

        this.trackingService.sendClickTrackingEvent(featureOrder, featureIndex, slide, position + 1, filledSlots, featureLabels, masTrackingFeatureLabels);
    }

    openAndTrackLeverLargeShoppromo(clickableItem, event, position, filledSlots) {
        // we have to open the sheet within the javascript code because the event.stopPropagation(), that is needed to prevent click tracking for the teaser,
        // prevents the pali layer open event.
        event.preventDefault();
        event.stopPropagation();
        const leverSheet = new window.o_global.pali.sheetBuilder({
            url: clickableItem.getAttribute("href"),
            lockMobileHeight: false
        });
        leverSheet.open();
        const container = this.findParentContainer(clickableItem, "ShopPromotionLarge");
        const featureOrder = this.getFeatureOrder(container);
        const featureIndex = this.getFeatureIndex(container);
        const masTrackingFeatureLabels = this.getMasFeatureTrackingLabels(container);
        let slide = new Slide(this.findAncestor(clickableItem, ".promo_shoppromo-large--item"));
        this.trackingService.sendLeverClickTrackingEvent(featureOrder, featureIndex, slide, position + 1, filledSlots, masTrackingFeatureLabels);
    }

    trackInitialViewLargeShopPromo(container) {
        const promoType = this.getPromoType(container);
        const featureOrder = this.getFeatureOrder(container);
        const sources = this.getSources(container, promoType);
        const filledSlots = sources.length;
        const featureIndex = this.getFeatureIndex(container);
        const featureLabels = this.getFeatureLabels(container)
        const masTrackingFeatureLabels = this.getMasFeatureTrackingLabels(container);

        if (container.getAttribute("data-isslidingcinemaenabled") === "false") {
            let slideContainers = container.querySelectorAll('.promo_shoppromo-large--item');
            let slides = [].map.call(slideContainers, container => new Slide(container));
            this.trackingService.sendLargeShoppromoInitialViewTrackingEvent(promoType, featureOrder, featureIndex, filledSlots, slides, featureLabels, masTrackingFeatureLabels);
        } else {
            let slideContainers = container.querySelectorAll('.promo_shoppromo-large--item');
            slideContainers[0].setAttribute("data-slidetracked", 'true');
            this.trackingService.sendLargeShoppromoInitialViewTrackingEvent(promoType, featureOrder, featureIndex, filledSlots, [new Slide(slideContainers[0])], featureLabels, masTrackingFeatureLabels);
        }
    }

    trackSlide(container, slideIndex, movementType) {
        const featureOrder = this.getFeatureOrder(container);
        const sources = this.getSources(container);
        const featureIndex = this.getFeatureIndex(container);
        const featureLabels = this.getFeatureLabels(container);
        const masTrackingFeatureLabels = this.getMasFeatureTrackingLabels(container);

        //decrease filled slots by 2 due to infinite slider buffer
        const filledSlots = sources.length - 2;
        let slideContainers = container.querySelectorAll('.promo_shoppromo-large--item');
        let slide = new Slide(slideContainers[slideIndex]);

        this.trackingService.sendSlideTrackingEvent(movementType, featureOrder, featureIndex, slide, slideIndex, filledSlots, featureLabels, masTrackingFeatureLabels);
    }

    getPromoType(container) {
        return container.getAttribute("data-promo-type");
    }

    getFeatureOrder(container) {
        return parseInt(container.parentElement.getAttribute('data-feature-order'), 0);
    }

    getMasFeatureTrackingLabels(container) {
        return JSON.parse(container.parentElement.getAttribute('data-feature-tracking-labels'));
    }

    getFeatureIndex(container) {
        return parseInt(container.getAttribute('data-feature-index'), 0);
    }

    getFeatureLabels(container) {
        return JSON.parse(container.getAttribute('data-feature-labels'));
    }

    getSources(container, promoType, startIndex, lastIndex) {
        const selector = promoType === 'ShopPromotionSmall' ? '.promo_shoppromo-small--tile' : '.promo_shoppromo-large--image-container';
        const shoppromoContainer = container.querySelectorAll(selector);

        startIndex = startIndex || 0;
        lastIndex = lastIndex || shoppromoContainer.length;

        return [].map
            .call(shoppromoContainer, shoppromoTile => shoppromoTile.getAttribute('data-source') || 'manual')
            .slice(startIndex, lastIndex);
    }

    findParentContainer(elem, promoType) {
        const className = promoType === 'ShopPromotionSmall' ? 'promo_shoppromo-small--container' : 'promo_shoppromo-large--container';
        while (!elem.classList.contains(className) && (elem = elem.parentElement)) ;
        return elem;
    }

    setTileTracked(container, lastIndex) {
        const tiles = container.querySelectorAll('.promo_shoppromo-small--tile');
        Array.from(tiles)
            .slice(0, lastIndex)
            .forEach(tile => tile.setAttribute("data-tracked", 'true'))
    }

    findAncestor(el, sel) {
        return el.closest(sel);
    }

    static loadImages(container) {
        const promoImages = container.querySelectorAll('.promo_shoppromo-large--image');
        const sources = container.querySelectorAll('.promo_shoppromo-large--picture source, .promo_shoppromo-large--overlay source');
        const logos = container.querySelectorAll('.promo_shoppromo-large--logo');

        //Replace placeholder images and picture sources with real ones
        for (let i = 0; i < promoImages.length; i++) {
            if (promoImages[i].getAttribute('data-src')) {
                promoImages[i].setAttribute('src', promoImages[i].getAttribute('data-src'));
            }
        }
        for (let i = 0; i < sources.length; i++) {
            if (sources[i].getAttribute('data-srcset')) {
                sources[i].setAttribute('srcset', sources[i].getAttribute('data-srcset'));
            }
        }
        for (let i = 0; i < logos.length; i++) {
            if (logos[i].getAttribute('data-src')) {
                logos[i].setAttribute('src', logos[i].getAttribute('data-src'));
            }
        }
    }
}
